module.exports = __webpack_public_path__ + "img/toggle.b2b50861.svg";